import AppRouter from './Routes/AppRouter.jsx';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';


export default function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  return <AppRouter />
}